import { MessageCircle, Rocket, ArrowDown, CheckCircle2 } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { waLink } from "../config";

const PRESETS = [
    {
        label: "Richiesta Consulenza IA",
        message: "Ciao Maria! Vorrei richiedere una consulenza sull'Intelligenza Artificiale Performance.",
    },
    {
        label: "Collaborazione Creator",
        message: "Ciao Maria! Sono un Creator e mi piacerebbe collaborare con te.",
    },
    {
        label: "Info Progetti",
        message: "Ciao Maria! Ho visto i tuoi progetti NovaX8 e SKAY1 e vorrei maggiori informazioni.",
    },
];

const PROJECT_POINTS = [
    { name: "NovaX8", detail: "Innovazione, tecnologia e nuove opportunità" },
    { name: "SKAY1", detail: "IA Performance, cashback e marketing innovativo" },
    { name: "Creator Plus", detail: "Formazione e crescita per i Creator" },
];

export const Contact = () => (
    <section
        id="contatti"
        data-testid="contact-section"
        className="py-20 sm:py-28 bg-gradient-to-b from-[#E0F7FA]/40 to-white"
    >
        <div className="mx-auto max-w-6xl px-5 sm:px-8 grid gap-10 lg:grid-cols-2">
            <Reveal>
                <div className="h-full rounded-3xl bg-[#03045E] p-8 sm:p-10 relative overflow-hidden">
                    <div
                        className="absolute -top-24 -right-24 h-64 w-64 rounded-full bg-[#0077B6]/40 blur-3xl"
                        aria-hidden="true"
                    />
                    <div className="relative">
                        <SectionLabel>Contatti</SectionLabel>
                        <h2
                            data-testid="contact-heading"
                            className="mt-5 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white leading-tight"
                        >
                            Scrivimi su WhatsApp:
                            <span className="block text-[#48CAE4]">parli direttamente con me.</span>
                        </h2>
                        <p className="mt-4 text-sm sm:text-base text-sky-100/80 leading-relaxed">
                            Scegli un argomento per avviare subito la chat con un
                            messaggio già pronto, oppure scrivimi liberamente.
                        </p>

                        <div className="mt-7 flex flex-wrap gap-2.5" data-testid="contact-presets">
                            {PRESETS.map((p, i) => (
                                <a
                                    key={p.label}
                                    href={waLink(p.message)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={`contact-preset-${i + 1}`}
                                    className="px-4 py-2.5 rounded-full text-xs sm:text-sm font-semibold text-sky-100 border border-[#0077B6] hover:bg-[#0077B6] hover:text-white transition-colors duration-300"
                                >
                                    {p.label}
                                </a>
                            ))}
                        </div>

                        <a
                            href={waLink("Ciao Maria! Ti contatto dal tuo sito ufficiale.")}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="contact-whatsapp-button"
                            className="group mt-8 inline-flex w-full sm:w-auto items-center justify-center gap-3 px-8 py-4 rounded-full text-base font-bold text-[#03045E] bg-[#25D366] hover:bg-[#48CAE4] shadow-xl shadow-emerald-500/20 transition-all duration-300 hover:-translate-y-0.5"
                        >
                            <MessageCircle className="h-5 w-5 transition-transform duration-300 group-hover:scale-110" />
                            Apri la chat WhatsApp
                        </a>
                    </div>
                </div>
            </Reveal>

            <Reveal delay={0.15}>
                <div
                    data-testid="projects-banner-card"
                    className="group h-full rounded-3xl bg-white border border-slate-200/80 shadow-xl shadow-sky-900/5 p-8 sm:p-10 hover:shadow-2xl hover:shadow-sky-500/15 hover:border-[#48CAE4] transition-all duration-500 hover:-translate-y-1"
                >
                    <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-sky-100 text-[#0077B6] transition-colors duration-300 group-hover:bg-[#0077B6] group-hover:text-white">
                        <Rocket className="h-6 w-6" />
                    </span>
                    <h3 className="mt-6 font-display text-xl sm:text-2xl font-bold text-[#03045E]">
                        I miei progetti partono da qui
                    </h3>
                    <p className="mt-3 text-sm sm:text-base text-slate-600 leading-relaxed">
                        Questo è il mio sito ufficiale: NovaX8 e SKAY1 si presentano
                        qui, e chi è interessato parla prima con me, senza intermediari.
                    </p>
                    <ul className="mt-6 space-y-3" data-testid="projects-banner-list">
                        {PROJECT_POINTS.map((p) => (
                            <li key={p.name} className="flex items-start gap-3 text-sm sm:text-base text-slate-600">
                                <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-[#0096C7]" />
                                <span>
                                    <strong className="text-[#03045E]">{p.name}</strong> — {p.detail}
                                </span>
                            </li>
                        ))}
                    </ul>
                    <a
                        href="#progetti"
                        data-testid="projects-banner-link"
                        className="mt-8 inline-flex items-center gap-2 text-base font-bold text-[#0077B6] hover:text-[#03045E] transition-colors"
                    >
                        Scopri i progetti
                        <ArrowDown className="h-5 w-5 transition-transform duration-300 group-hover:translate-y-0.5" />
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);
